var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2225 19.43L10 14.8567L3.77749 19.43L6.16666 12.0442L-0.0525055 7.5H7.62583L10 0.101669L12.3742 7.5H20.0517L13.8333 12.0442L16.2225 19.43ZM10 12.7883L13.0483 15.0292L11.8817 11.4092L14.9475 9.16667H11.1583L10 5.5575L8.84166 9.16667H5.05166L8.12083 11.4092L6.95416 15.0292L10 12.7883Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.494a588feb4ffedbdec7adb54819ebc0.svg";
export { ForwardRef as ReactComponent };